/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolGiteIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-gite"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M3.85 19.8Q2.73 19.8 1.96 19.04Q1.2 18.27 1.2 17.15L1.2 10.9Q1.2 10.38 1.4 9.89Q1.6 9.4 1.98 9.03L4.95 6.03Q5.25 5.72 5.65 5.55Q6.05 5.38 6.47 5.38L6.47 5.38L6.47 4.53Q6.47 3.98 6.86 3.59Q7.25 3.2 7.8 3.2Q8.35 3.2 8.74 3.59Q9.13 3.98 9.13 4.53L9.13 5.38L17.32 5.38Q17.85 5.38 18.34 5.58Q18.82 5.78 19.2 6.15L22.02 9.03Q22.4 9.4 22.6 9.89Q22.8 10.38 22.8 10.9L22.8 17.15Q22.8 18.27 22.04 19.04Q21.27 19.8 20.15 19.8ZM16.45 17.15L20.15 17.15Q20.15 17.15 20.15 17.15Q20.15 17.15 20.15 17.15L20.15 10.93L18.3 9.03L16.45 10.93ZM13.8 17.15L13.8 12.3L3.85 12.3L3.85 17.15Q3.85 17.15 3.85 17.15Q3.85 17.15 3.85 17.15Z" fill={color} />
    </svg>
  );
}
